var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNextAbu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.92001 0.420007L10.46 8.00001C10.7238 8.26597 10.8718 8.6254 10.8718 9.00001C10.8718 9.37461 10.7238 9.73405 10.46 10L2.46001 18C2.19157 18.2591 1.83307 18.4039 1.46001 18.4039C1.08694 18.4039 0.728441 18.2591 0.460006 18C0.200935 17.7316 0.0561523 17.3731 0.0561523 17C0.0561523 16.6269 0.200935 16.2684 0.460006 16L6.46001 10C6.72381 9.73405 6.87184 9.37461 6.87184 9.00001C6.87184 8.6254 6.72381 8.26597 6.46001 8.00001L0.900006 2.44001C0.636198 2.17405 0.488172 1.81461 0.488172 1.44001C0.488172 1.0654 0.636198 0.705969 0.900006 0.440007C1.03075 0.305053 1.18697 0.197389 1.35963 0.123253C1.53229 0.0491182 1.71794 0.00998654 1.90583 0.00812624C2.09372 0.00626594 2.28011 0.041714 2.4542 0.112416C2.62829 0.183118 2.78662 0.287668 2.92001 0.420007Z",
    fill: "#424244"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNextAbu);
export default __webpack_public_path__ + "static/media/Icon_Next_Abu.bd49cc91.svg";
export { ForwardRef as ReactComponent };